import { render, staticRenderFns } from "./tableData.vue?vue&type=template&id=11adf9f8&scoped=true"
import script from "./tableData.vue?vue&type=script&lang=js"
export * from "./tableData.vue?vue&type=script&lang=js"
import style0 from "./tableData.vue?vue&type=style&index=0&id=11adf9f8&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "11adf9f8",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/jenkins_home/workspace/test-crmeb-admin-front-service/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('11adf9f8')) {
      api.createRecord('11adf9f8', component.options)
    } else {
      api.reload('11adf9f8', component.options)
    }
    module.hot.accept("./tableData.vue?vue&type=template&id=11adf9f8&scoped=true", function () {
      api.rerender('11adf9f8', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/statistic/product/components/tableData.vue"
export default component.exports